import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'contaBancaria'
})
export class ContaBancariaPipe implements PipeTransform {

  transform(conta: any, args?: any): any {
    if (conta !== undefined && conta !== null) {
      let strDigitoAgencia = '';

      if (conta.agenciaDigito && conta.agenciaDigito.length > 0) {
        strDigitoAgencia = '-' + conta.agenciaDigito;
      }
      return 'Banco: ' + conta.banco.codigo + ' Ag.: ' + conta.agencia + strDigitoAgencia + ' C. '
        + (conta.poupanca ? 'Poupança' : 'Corrente') + ': '
        + conta.numero + '-' + conta.numeroDigito + ' (' + conta.titularNome + ')';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/pipes/conta-bancaria.pipe.ts